// Redeemable credentials that must never reach analytics context, session
// replay, or referrer headers. Scrubbed on consumption and before any page
// event fires.
const SENSITIVE_URL_PARAMS = ["inviteToken"];

export function scrubSensitiveUrlParams(): void {
  if (typeof window === "undefined" || !window.history?.replaceState) {
    return;
  }
  const url = new URL(window.location.href);
  let dirty = false;
  for (const param of SENSITIVE_URL_PARAMS) {
    if (url.searchParams.has(param)) {
      url.searchParams.delete(param);
      dirty = true;
    }
  }
  if (dirty) {
    // Address bar only: the router's parsed query is untouched, so in-memory
    // consumers keep the value; a hard reload loses the param by design.
    window.history.replaceState(window.history.state, "", url);
  }
}
